export interface FileContentResult {
  /**
   * format: byte
   */
  fileContents: string;

  contentType?: string;

  fileDownloadName?: string;
  /**
   * format: date-time
   */
  lastModified?: string;

  entityTag: EntityTagHeaderValue;

  enableRangeProcessing: boolean;
}

export interface EntityTagHeaderValue {
  tag: StringSegment;
  isWeak: boolean;
}

export interface StringSegment {
  buffer: string;
  offset: number;
  length: number;
  value: string;
  hasValue: boolean;
}

export interface AcceptTermsOfServiceDto {
  /**
   * minLength: 0
   * maxLength: 20
   */
  termsVersion: string;
  legalName: string;
}
